define('views/modules/template/edit/modal/exercises-not-found-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // views
    'views/parts/modal/modal'

], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // views
    VModal
) {

    var VExerciseNotFoundModal = VModal.extend({

        template: '<p>{{#t}}general:exercise-not-found-modal-message{{/t}}</p><ul>{{#errors}}<li>{{.}}</li>{{/errors}}</ul>',

        modal: function() {
            return {
                title: i18n.t('general:exercise-not-found-modal-title'),
                buttons: {
                    confirm: {
                        label: i18n.t("Ok"),
                        callback: this.onCancel
                    },
                }
            };
        },

        initialize: function(options) {
            this.options = _.extend({}, options);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                errors: this.options.errors
            })));

            return this.renderModal();
        },

    });

    return VExerciseNotFoundModal;
});

